import { useQuery } from '@tanstack/react-query';
import type { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { useAuth } from '@/app/auth/context';
import { PageHeader } from '@/components/admin/AdminShell';
import { fetchThread, threadHeading } from '@/features/messages/api';
import { ThreadConversation } from '@/features/messages/ThreadConversation';

/** スレッド詳細（メッセージ全件・返信 / 指示書 §12 M8）. */
export function ThreadDetailPage(): ReactElement {
  const { threadId = '' } = useParams<{ threadId: string }>();
  const { user } = useAuth();
  // 見出しに件名・種別を出すため（本文の取得は ThreadConversation 側と同じキーで共有される）
  const query = useQuery({ queryKey: ['thread', threadId], queryFn: () => fetchThread(threadId) });
  const thread = query.data;

  return (
    <>
      <PageHeader
        title={thread ? threadHeading(thread) : 'スレッド'}
      />
      {user && <ThreadConversation threadId={threadId} currentUserId={user.id} />}
    </>
  );
}
